<template>
  <div id="layout">
    <div class="header" :class="navBarFixed == true ? 'navBarWrap' : ''">
      <div class="wrap">
        <div class="wrapLeft">
          <div class="imgbox" @click="gohome">
            <img src="@/assets/home/navlogo.png" alt />
          </div>
          <ul>
            <li
              v-for="(item, index) in menuList"
              :key="index"
              @click="changPage(item)"
              :class="{ active: current == item }"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div v-if="isLogin == 0" class="newuser">
          <span class="loginuser" :title="username">{{
            username.length > 8
              ? username.substring(0, 8).concat("...")
              : username
          }}</span>
          <img v-if="icon==''||icon=='null'||icon==null" src="../assets/mine/touxiang.png" alt="">
          <img v-else :src="icon" alt />
          <div class="statusModel">
            <p class="roleshow" :title="username">
              <span class="namespan">{{
                username.length > 10
                  ? username.substring(0, 10).concat("...")
                  : username
              }}</span>

              <span v-if="role == '学生'" class="rolespan">学生</span>
              <span v-else class="rolespan">教师</span>
            </p>
            <p
              class="mineshow"
              :class="{ useractive: usershow }"
              @click="tomine"
            >
              <span></span>个人中心
            </p>
            <p class="loginshow" @click="removeuser(null)">
              <span></span>退出登录
            </p>
          </div>
        </div>

        <div class="user" v-else>
          <li @click="isShowBox()">登录</li>
          <li @click="toregister()">注册</li>
          <!-- <span @click="isShowBox()">登录|</span>
          <span @click="toregister()">注册</span> -->
        </div>
      </div>
    </div>

    <div class="content">
      <router-view></router-view>
    </div>
    <div class="footer">
      <div class="top">
        <div class="left">
          <span>友情链接</span>
          <span>LINKS</span>
        </div>
        <div class="right">
          <ul>
            
            <li><a href="http://www.gdcourse.com/" target="_blank">武汉高德信息产业有限公司</a></li>
            <li><a href="http://www.huazhongcnc.com/" target="_blank">武汉华中数控股份有限公司</a></li>
            <li><a href="https://www.hsrobotics.cn/" target="_blank">华数机器人有限公司</a></li>
            <li><a href="http://www.foshaniei.com/" target="_blank">佛山智能装备研究院</a></li>
          </ul>
        </div>
      </div>
      <!-- <div class="mod">
        <div class="left">
          <span>校企合作</span>
          <span>CONTACT</span>
        </div>
        <div class="right">
          <ul>
            <li><a href="http://www.gdcourse.com/" target="_blank">武汉高德信息产业有限公司</a></li>
            <li><a href="http://www.huazhongcnc.com/" target="_blank">武汉华中数控股份有限公司</a></li>
            <li><a href="" target="_blank">重庆华数机器人有限公司</a></li>
          </ul>
        </div>
      </div> -->
      <div class="under">Copyright©2016   鄂ICP备15018399号-2     鄂公网安备 42011102000667号 </div>
    </div>
    <loginModal
      :isShow="isShow"
      @closemodal="isShow = false"
      @logined="logined"
      @goregister="goregister"
      @forget="forget"
    ></loginModal>
  </div>
</template>
<script>
import { logoutApi } from "@/request/api";
import loginModal from "@/components/common/loginModal";
// import { mapState,mapMutations} from 'vuex'
export default {
  name: "layout",
  components: { loginModal },
  watch: {
    $route(to) {
      let arr = to.path.split("/");
      this.locationPage(arr[arr.length - 1]);
    },
  },
  sockets:{
    logout(){
      console.log("登出")
    },
    testRoom(){
      console.log("测试")
    },
  },
  created() {
    // this.username=localStorage.getItem("username")
    if (localStorage.getItem("username")) {
      this.remindUserInfo();
    }
    //接收服务端的信息
    this.sockets.subscribe('testRoom', (data) => {
        console.log('接收的信息有：',data)
    })
  },
  mounted() {
    window.addEventListener("scroll", this.watchScroll);

    let arr = window.location.pathname.split("/");
    switch (arr[arr.length - 1]) {
      case "":
        this.current = "首页";
        break;
      case "Course":
        this.current = "课程中心";
        break;
      case "courseInfo":
        this.current = "课程中心";
        break;
      case "catalog":
        this.current = "课程中心";
        break;
      case "catalogDetail":
        this.current = "课程中心";
        break;
      case "answer":
        this.current = "课程中心";
        break;
      case "answerDetail":
        this.current = "课程中心";
        break;
      case "answerNew":
        this.current = "课程中心";
        break;
      case "theoryTrain":
        this.current = "理论训练";
        break;
      case "startexam":
        this.current = "理论训练";
        break;
      case "simulation":
        this.current = "仿真实训";
        break;
      case "simulationDetail":
        this.current = "仿真实训";
        break;
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    username() {
      return this.$store.state.username;
    },
    icon() {
      return this.$store.state.icon;
    },
    role() {
      return this.$store.state.role;
    },
  },
  data() {
    return {
      menuList: ["首页", "课程中心", "理论训练", "仿真实训"],
      current: "",
      isShow: false,
      navBarFixed: false,
      usershow: false,
    };
  },
  methods: {
    changPage(data) {
      this.current = data;
      let path = "";
      switch (data) {
        case "首页":
          path = "/";
          break;
        case "课程中心":
          path = "/Course";
          break;
        case "理论训练":
          path = "/theoryTrain";
          break;
        case "仿真实训":
          path = "/simulation";
          break;
      }
      this.$router.push({ path: path });
    },
    gohome() {
      this.$router.push({ path: "/" });
    },
    remindUserInfo() {
      this.$store.commit("toggleIsLogin", {
        isLogin: localStorage.getItem("isLogin"),
        role: localStorage.getItem("role"),
        username: localStorage.getItem("username"),
        icon: localStorage.getItem("icon"),
        authentation: localStorage.getItem("authentation"),
      });
    },
    isShowBox() {
      this.isShow = true;
    },
    toregister() {
      this.$router.push({ path: "/register" }); //点击注册按钮去到注册页
    },
    logined() {
      this.isShow = false;
    },
    tomine() {
      this.$router.push({ path: "/basicInfo" });
    },
    goregister() {
      this.$router.push({ path: "/register" }); //点击登录页的去注册
      this.isShow = false;
    },
    forget() {
      this.$router.push({ path: "/forgetModal" });
      this.isShow = false;
    },
    //清除登录状态
    removeuser() {
      this.$confirm({
        title: "确定要退出吗？",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          this.getToken(logoutApi, {}, (res) => {
            if (res.code == 200) {
              localStorage.setItem("isLogin", 1);
              localStorage.setItem("role", "");
              localStorage.setItem("username", "");
              localStorage.setItem("icon", "");
              localStorage.setItem("token", "");
              localStorage.setItem("authentation", "");
              localStorage.setItem("taskId", "");
              localStorage.setItem("chapterId", "");
              this.$store.commit("toggleIsLogin", {
                isLogin: 1,
                role: null,
                username: null,
                icon: null,
                token: null,
                authentation: null,
              });
              //清空教学课堂的完成与否
              this.$store.commit("getIds", {
                chapterId: null,
                taskId: null,
              });
              this.$socket.emit('logout','')
              //退出登录跳到首页
              this.$router.push({ path: "/" });
            }
          });
        },
        onCancel() {
          // console.log(123)
        },
      });
    },
    locationPage(page) {
      if (
        page == "basicInfo" ||
        page == "manClass" ||
        page == "manstudent" ||
        page == "message" ||
        page == "myanswer" ||
        page == "myask" ||
        page == "myexam" ||
        page == "myPurge" ||
        page == "myreply" ||
        page == "myscore" ||
        page == "mystudent" ||
        page == "mysubject" ||
        page == "mytrain" ||
        page == "studyview" ||
        page == "trainexam" ||
        page == "myviedo" ||
        page == "myClass"
      ) {
        this.current = "";
      } else {
        // this.isShowHeader = false;
      }
      switch (page) {
        case "":
          this.current = "首页";
          break;
        case "Course":
          this.current = "课程中心";
          break;
        case "courseInfo":
          this.current = "课程中心";
          break;
        case "catalog":
          this.current = "课程中心";
          break;
        case "catalogDetail":
          this.current = "课程中心";
          break;
        case "answer":
          this.current = "课程中心";
          break;
        case "answerDetail":
          this.current = "课程中心";
          break;
        case "answerNew":
          this.current = "课程中心";
          break;
        case "theoryTrain":
          this.current = "理论训练";
          break;
        case "startexam":
          this.current = "理论训练";
          break;
        case "simulation":
          this.current = "仿真实训";
          break;
        case "simulationDetail":
          this.current = "仿真实训";
          break;
        case "register":
          this.current = " ";
          break;
        case "forgetModal":
          this.current = " ";
          break;
      }
    },
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //  当滚动超过 50 时，实现吸顶效果
      if (scrollTop > 80 && !this.navBarFixed) {
        this.navBarFixed = true;
      } else if (scrollTop < 2 && this.navBarFixed) {
        this.navBarFixed = false;
        // console.log(`scrollTop${scrollTop}`);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
#layout {
  font-family: MicrosoftYaHei;

  .header {
    height: 80px;
    box-shadow: 0px 0px 10px 0px rgba(92, 93, 93, 0.2);

    .wrap {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      height: 80px;

      .wrapLeft {
        display: flex;
        flex: 1;
        align-items: center;

        .imgbox {
          width: 241px;
          height: 80px;

          img {
            margin-top:20px;
            cursor: pointer;
          }
        }

        ul {
          display: flex;
          margin: 0;
          padding-left: 84px;

          li {
            font-size: 16px;
            color: #333;
            cursor: pointer;
            height: 50px;
            line-height: 50px;
            min-width: 50px;
            margin-right: 30px;
            text-align: center;
            position: relative;
          }

          li:before, li:after {
            content: '';
            position: absolute;
          }

          li:after {
            border-bottom: 2px solid #f0cd48;
            left: 51%;
            right: 51%;
            bottom: 0;
            -webkit-transition-property: all;
            -moz-transition-property: all;
            -o-transition-property: all;
            transition-property: all;
            -webkit-transition-timing-function: cubic-bezier(0, 0.98, 0.51, 0.93);
            -moz-transition-timing-function: cubic-bezier(0, 0.98, 0.51, 0.93);
            -o-transition-timing-function: cubic-bezier(0, 0.98, 0.51, 0.93);
            transition-timing-function: cubic-bezier(0, 0.98, 0.51, 0.93);
            -webkit-transition-duration: 200ms;
            -moz-transition-duration: 200ms;
            -o-transition-duration: 200ms;
            transition-duration: 200ms;
            -webkit-transition-delay: 0s;
            -moz-transition-delay: 0s;
            -o-transition-delay: 0s;
            transition-delay: 0s;
          }

          li:hover:after {
            cursor: pointer;
            left: 0%;
            right: 0%;
          }

          li:after {
            -webkit-transition-delay: 0s;
            -moz-transition-delay: 0s;
            -o-transition-delay: 0s;
            transition-delay: 0s;
          }

          .active {
            border-bottom: 2px solid #f0cd48;
          }
        
          .active:after{
              display:none;
          }
      
          li:last-child {
            margin-right: 0px;
          }
        }
      }

      .user {
        // font-size: 14px;
        // padding-left: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 30px;
        background-color: #efca45;
        border-radius: 15px;

        li:nth-child(1) {
          list-style: none;
          border-right: 1px solid #000;
          color: #333;
          font-size: 14px;
          width: 35px;
          height: 14px;
          line-height: 14px;
        }

        li:nth-child(2) {
          list-style: none;
          color: #41b5f1;
          font-size: 14px;
          width: 35px;
          padding-left: 5px;
          height: 14px;
          line-height: 14px;
        }

        li:hover {
          cursor: pointer;
        }
      }

      .newuser {
        color: #333;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        height: 80px;

        // background:yellow;
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-top: -3px;
        }

        .loginuser {
          height: 20px;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          letter-spacing: 0px;
          color: #f0cd48;
          margin-right: 15px;
          max-width: 125px;
          overflow: hidden;
          display: flex;
          color: #000;
          z-index: 666;
        }

        .statusModel {
          width: 181px;
          height: 145px;
          background: #fff;
          color: #333;
          z-index: 999;
          position: absolute;
          bottom: -145px;
          right: -25px;
          display: none;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
          border-radius: 3px;

          p {
            width: 100%;
            margin-bottom: 0;
            padding-left: 20px;
            cursor: pointer;
          }

          .roleshow {
            height: 56px;
            border-bottom: 1px solid #eee;
            line-height: 56px;
            position: relative;

            .namespan {
              font-weight: 600;
            }

            .rolespan {
              width: 56px;
              height: 16px;
              line-height: 16px;
              font-weight: 0;
              font-family: MicrosoftYaHei;
              font-size: 12px;
              background-color: #f34b3f;
              border-radius: 2px;
              position: absolute;
              text-align: center;
              right: 0;
              top: 0;
              color: #fff;
            }
          }

          .mineshow {
            display: flex;
            align-items: center;
            height: 40px;
            line-height: 40px;

            span {
              width: 15px;
              height: 16px;
              display: block;
              margin-right: 9px;
              background: url('../assets/home/mine1.png');
            }
          }

          .loginshow {
            display: flex;
            align-items: center;
            height: 40px;
            line-height: 40px;

            span {
              width: 15px;
              height: 16px;
              display: block;
              margin-right: 9px;
              background: url('../assets/home/login1.png');
            }
          }

          .loginshow:hover {
            background-color: #f0cd48;
            color: #fff;

            span {
              background: url('../assets/home/login2.png');
            }
          }

          .mineshow:hover {
            background-color: #f0cd48;
            color: #fff;

            span {
              background: url('../assets/home/mine2.png');
            }
          }

          p:last-child {
            border-bottom: 0px;
          }
        }
      }

      .newuser:hover {
        .loginuser {
          color: #f0cd48;
        }

        .statusModel {
          display: block;
        }
      }
    }
  }

  .navBarWrap {
    position: fixed;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    border-bottom: 1px solid #eee;
    background: rgba(255, 255, 255, 1);
    color: #f0cd48;
    z-index: 999;
    box-shadow: 0px 4px 9px 0px rgba(73, 83, 104, 0.2);
  }

  .footer {
    height: 130px;
    margin: 0 auto;
    background-color: #272c32;
    overflow: hidden;

    .top {
      width: 1205px;
      margin: 0 auto;
      margin-top: 25px;
      margin-bottom: 15px;
      height: 20px;
      line-height: 20px;
      display: flex;

      .left {
        width: 210px;

        span:nth-child(1) {
          color: #ffffff;
          font-size: 16px;
        }

        span:nth-child(2) {
          color: #f0cd48;
          margin-left: 4px;
          font-size: 15px;
        }
      }

      .right {
        flex: 1;

        ul {
          width: 100%;
          display: flex;

          li {
            font-size: 14px;
            color: #fff;
            margin-right: 10px;
            a{
              color:#fff;
            }
            a:hover{
              color:#ef9545;
            }
          }
        }
      }
    }

    .mod {
      width: 1205px;
      margin: 0 auto;
      margin-bottom: 20px;
      height: 20px;
      display: flex;

      .left {
        width: 210px;

        span:nth-child(1) {
          color: #ffffff;
          font-size: 16px;
        }

        span:nth-child(2) {
          color: #f0cd48;
          margin-left: 4px;
          font-size: 15px;
        }
      }

      .right {
        flex: 1;

        ul {
          width: 100%;
          display: flex;

          li {
            font-size: 14px;
            color: #fff;
            margin-right: 10px;
            a{
              color:#fff;
            }
            a:hover{
              color:#ef9545;
            }
          }
        }
      }
    }

    .under {
      border-top: solid 1px #595858;
      width: 1205px;
      margin: 0 auto;
      font-size: 12px;
      color: #999999;
      text-align: center;
      padding-top: 30px;
      padding-bottom: 10px;
    }
  }
}
</style>

